import React from 'react'
import Header from '../Home/Header';
import Footer from '../Home/Footer';
import Intusty2 from "../About/Intusty2";
import Intusty3 from './Intusty3';
const Intusty = () => {
  return (
    <>
      <Header />
      <Intusty2 />
      <Intusty3 />
      <Footer />
    </>
  );
};

export default Intusty